import type { AppState } from '@store/types'

export const selectApiUsage = (state: AppState) => state.apiUsage.data

export const selectApiUsageError = (state: AppState) => state.apiUsage.error
